import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';

/** 右側滑出抽屜。
 *  Radix Dialog 已內建焦點陷阱、Esc 關閉、焦點歸還與 aria-modal，
 *  行為與原生版的 openDrawer 一致，不必自己實作。
 */
export function Drawer({
  open,
  onOpenChange,
  title,
  children,
  wide,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  title: string;
  children: ReactNode;
  wide?: boolean;
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        {/* 層級先於內容：背景先淡入，面板才滑出 */}
        <Dialog.Overlay className="drawer-overlay fixed inset-0 z-[60] bg-black/45 backdrop-blur-[2px]" />
        <Dialog.Content
          className={
            'drawer-panel fixed right-0 top-0 z-[70] flex h-[100dvh] w-full flex-col bg-card shadow-2xl ' +
            'focus:outline-none ' + (wide ? 'max-w-[840px]' : 'max-w-[560px]')
          }
        >
          <div className="flex items-center justify-between gap-4 border-b border-border px-6 py-4">
            <Dialog.Title className="min-w-0 break-words font-display text-[17px] font-bold">{title}</Dialog.Title>
            <Dialog.Close asChild>
              <Button variant="ghost" size="sm" aria-label="關閉對話框">
                <X className="h-4 w-4" />
                <span>關閉</span>
              </Button>
            </Dialog.Close>
          </div>
          <div className="min-h-0 flex-1 overflow-y-auto p-5 pb-[max(20px,env(safe-area-inset-bottom))] sm:p-6">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
